import { Box, styled } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { AddCircleOutline, ArrowRightAlt } from "@mui/icons-material";
import { AppRoutes } from "../../config";
import useAuthorization from "../../contexts/useAuthorization";

const Bar = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin: 0;
  position: relative;
  padding: 0 24px;
  border-radius: 20px;
  background: #2b3501;
  height: 64px;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 16px;
  color: #ffffff;

  @media (max-width: 560px) {
    padding: 0 18px;
  }
`;

const BannerText = styled("div")`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.21;
  color: #ffffff;
  white-space: nowrap;

  .banner-full {
    display: inline-flex;
    align-items: center;
  }

  .banner-compact {
    display: none;
  }

  svg {
    margin-left: 8px;
    font-size: 18px;
  }

  @media (max-width: 560px) {
    font-size: 14px;

    .banner-full {
      display: none;
    }

    .banner-compact {
      display: inline;
    }
  }
`;

const BannerIcon = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-decoration: none;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  background-color: #f2f2f2;

  svg {
    width: 22px;
    height: 22px;
    color: #000000;
  }

  @media (max-width: 560px) {
    width: 32px;
    height: 32px;

    svg {
      width: 19px;
      height: 19px;
    }
  }
`;

const GuardianUploadBanner = () => {
  const { isGuardian, isPioneer } = useAuthorization();

  // Pioneers (invite code redeemed, no land minted yet) upload too — minting their first land is
  // what makes them Guardians — so only the greeting differs.
  if (!isGuardian && !isPioneer) return null;

  return (
    <Bar>
      <BannerText>
        <span className="banner-full">
          <Box component="span" sx={{ fontWeight: 700 }}>
            {isGuardian ? "Guardians, upload your land here;" : "Pioneers, upload your first land here;"}
          </Box>
          <Box component="span" sx={{ fontWeight: 400 }}>
            &nbsp;let your covenant take root.
          </Box>
          <ArrowRightAlt />
        </span>
        <span className="banner-compact">Upload</span>
      </BannerText>
      <BannerIcon to={AppRoutes.Upload.path} aria-label="Upload your land">
        <AddCircleOutline />
      </BannerIcon>
    </Bar>
  );
};

export default GuardianUploadBanner;
